import { ManagerAuthorityEnum } from "../types/typescript-axios";

export function translateManagerAuthority(authority: ManagerAuthorityEnum) {
  if (authority === 'ADMIN') return '管理者'

  if (authority === 'STAFF') return 'スタッフ'

  return 'ゲスト';
}